import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-advertorial-client',
  templateUrl: './advertorial-client.component.html',
  styleUrls: ['./advertorial-client.component.scss'],
})
export class AdvertorialClientComponent {
  @Input() sponsoredClientControl: FormControl;
  @Input() salesOrderControl: FormControl;
  @Input() isExpandedByDefault = false;
  @Input() isExpandable = true;
}
